import { useState } from "react";
import { CreditCard } from "lucide-react";
import { inr } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";

export const EMI_MIN = 3000;
const BANKS = [["HDFC Bank", 15], ["ICICI Bank", 15.5], ["SBI Card", 14], ["Axis Bank", 15], ["Kotak Bank", 16]];
const TENURES = [3, 6, 9, 12];

export const emi = (amt, rate, n) => { const r = rate / 1200; return (amt * r * (1 + r) ** n) / ((1 + r) ** n - 1); };
export const emiFrom = (amt) => Math.min(...BANKS.map(([, r]) => emi(amt, r, 12)));

export default function EmiPlans({ amount, testid = "emi" }) {
  const [bank, setBank] = useState(BANKS[0][0]);
  if (amount < EMI_MIN) return null;
  const rate = BANKS.find((b) => b[0] === bank)[1];
  return (
    <Dialog>
      <DialogTrigger data-testid={`${testid}-open`} className="w-full flex items-center gap-2 text-left text-sm rounded-xl bg-white/5 border border-white/10 px-4 py-3 hover:border-[#00f0ff]/50 transition-colors">
        <CreditCard size={16} className="text-[#00f0ff] shrink-0" />
        <span className="flex-1">EMI from <b data-testid={`${testid}-from`}>{inr(Math.round(emiFrom(amount)))}/month</b> on credit cards</span>
        <span className="text-xs text-[#00f0ff] font-semibold">View plans</span>
      </DialogTrigger>
      <DialogContent className="bg-[#12141c] border-white/10 max-w-lg" data-testid={`${testid}-dialog`}>
        <DialogHeader><DialogTitle>EMI plans for {inr(amount)}</DialogTitle></DialogHeader>
        <div className="flex flex-wrap gap-2">
          {BANKS.map(([b]) => (
            <button key={b} data-testid={`${testid}-bank-${b.split(" ")[0].toLowerCase()}`} onClick={() => setBank(b)} className={`px-3 py-1.5 rounded-full text-xs border ${b === bank ? "bg-white text-black border-white" : "border-white/15"}`}>{b}</button>
          ))}
        </div>
        <table className="w-full text-sm mt-2" data-testid={`${testid}-table`}>
          <thead><tr className="text-left text-xs text-slate-500"><th className="py-2">Tenure</th><th>Monthly EMI</th><th>Interest ({rate}% p.a.)</th><th>Total</th></tr></thead>
          <tbody>
            {TENURES.map((n) => { const m = emi(amount, rate, n); return (
              <tr key={n} className="border-t border-white/10"><td className="py-2.5">{n} months</td><td className="font-semibold">{inr(Math.round(m))}</td><td className="text-slate-400">{inr(Math.round(m * n - amount))}</td><td>{inr(Math.round(m * n))}</td></tr>
            ); })}
          </tbody>
        </table>
        <p className="text-[11px] text-slate-500">Approximate amounts. Final EMI, interest and GST on interest are set by your bank. Choose EMI in the card payment step at checkout (online payment).</p>
      </DialogContent>
    </Dialog>
  );
}
